import styled, { css } from 'styled-components'

export const RowGroup = styled.div<{ $isDragging: boolean }>`
  position: relative;

  ${({ $isDragging }) =>
    $isDragging &&
    css`
      background: var(--bg-transparent-strong);
    `};
`
